<template>
  <div id="app">
    <loading :active.sync="loading" :can-cancel="true" :color="colorLoader" :is-full-page="true"></loading>
    <router-view />
  </div>
</template>

<style src="@/vendor/styles/bootstrap.scss" lang="scss"></style>
<style src="@/vendor/styles/appwork.scss" lang="scss"></style>
<style src="@/vendor/styles/theme-sunrise.scss" lang="scss"></style>
<style src="@/vendor/styles/colors.scss" lang="scss"></style>
<style src="@/vendor/styles/uikit.scss" lang="scss"></style>
<style src="./style.scss" lang="scss"></style>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "app",
  metaInfo: {
    title: "Index",
    titleTemplate: "Rezerwacje internetowe - %s"
  },
  components: {
    Loading
  },
  data() {
    return {
      colorLoader: "#be1b53"
    };
  },
  computed: {
    loading() {
      return this.$store.getters.loading;
    }
  },
  updated() {
    // Remove loading state
    setTimeout(() => document.body.classList.remove("app-loading"), 1);
  }
};
</script>